import { useState, useEffect } from 'react';
import { API_CONFIG } from '../config/api';

// Cache simples em nível de módulo para evitar dupla chamada em desenvolvimento (StrictMode)
let unitsCache = null;
let cacheTimestamp = 0;
const CACHE_TTL_MS = 60_000; // 1 minuto

const useUnits = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUnits = async (force = false) => {
    try {
      setLoading(true);
      setError(null);
      const now = Date.now();
      const isCacheValid = unitsCache && (now - cacheTimestamp < CACHE_TTL_MS);
      
      // Usa cache em segunda montagem do StrictMode
      if (!force && isCacheValid) {
        setUnits(unitsCache);
        return;
      }
      
      const response = await fetch(`${API_CONFIG.baseURL}/units`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error('Erro ao carregar unidades');
      }
      
      const data = await response.json();
      const normalized = data.data || data;
      setUnits(normalized);
      unitsCache = normalized;
      cacheTimestamp = Date.now();
    } catch (err) {
      console.error('Error fetching units:', err);
      setError(err.message || 'Erro ao carregar unidades');
      setUnits([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  const getUnitByKey = (key) => {
    return units.find(unit => unit.key === key);
  };

  const getUnitName = (key) => {
    const unit = getUnitByKey(key);
    return unit ? unit.displayName : key;
  };

  return {
    units,
    loading,
    error,
    fetchUnits,
    getUnitByKey,
    getUnitName,
    refetch: () => fetchUnits(true)
  };
};

export default useUnits;